import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  Breadcrumbs,
  Link,
  CircularProgress
} from '@mui/material';
import { MarketsManagement } from '../../components/admin/MarketsManagement';
import { useCurrentUser } from '../../hooks/useApi';
import { Navigate, useNavigate } from 'react-router-dom';
import { Map, Home } from '@mui/icons-material';

export const ReportsAdmin: React.FC = () => {
  const { data: user, isLoading } = useCurrentUser();
  const navigate = useNavigate();

  // Show loading spinner while user data is being fetched
  if (isLoading) {
    return (
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  // Redirect if user doesn't have admin or customize permission (after loading completes)
  if (!user?.permissions?.includes('market_compass.admin') && !user?.permissions?.includes('market_compass.customize')) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link
            color="inherit"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <Home sx={{ mr: 0.5 }} fontSize="small" />
            Home
          </Link>
          <Link
            color="inherit"
            href="/admin/hub"
            onClick={(e) => {
              e.preventDefault();
              navigate('/admin/hub');
            }}
            sx={{ cursor: 'pointer' }}
          >
            Admin Hub
          </Link>
          <Typography color="text.primary">Market Management</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Map sx={{ mr: 2, fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h4" component="h1">
              Market Management
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary">
            View and manage all markets in the system
          </Typography>
        </Box>

        {/* Markets Management Component */}
        <MarketsManagement />
      </Box>
    </Container>
  );
};